<template>
	<div :id="id" class="c-search-section-self-services">
		<div
			:class="[
				'grid gap-layout-gutter',
				'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
			]"
		>
			<ContentCard
				v-for="(item, index) in items"
				:key="`item-${index}`"
				:title="item.name"
				:teaser="item.teaser"
				:link="{ url: item.url }"
			>
				<template v-if="item && item.targetGroups" #before>
					<span
						class="font-darker-grotesque font-semibold"
						v-html="item.targetGroups[0]"
					></span>
				</template>

				<template #after>
					<div class="flex items-center space-x-12 mt-lg">
						<div
							:class="[
								'c-search-section-page__button',
								'flex items-center justify-center',
								'w-24 h-24 rounded-full border-black',
								{
									'bg-black  text-white':
										computedExternal[index],
								},
							]"
						>
							<SvgArrow
								:class="[
									'w-12',
									{
										'transform -rotate-45':
											computedExternal[index],
									},
								]"
							/>
						</div>

						<span
							:class="[
								'font-bold font-darker-grotesque',
								'uppercase text-button-xs',
							]"
							v-text="'Læs mere'"
						></span>
					</div>
				</template>
			</ContentCard>
		</div>
	</div>
</template>

<script>
import SvgArrow from '~/assets/svgs/icon-arrow.svg?inline';
import ContentCard from '~/components/shared/ContentCard';

export default {
	name: 'SearchSectionSelfServices',
	components: { SvgArrow, ContentCard },

	props: {
		id: {
			type: String,
			required: true,
		},

		items: {
			type: Array,
			default: () => [],
		},
	},

	computed: {
		computedExternal() {
			return this.items.map((item) => this.isExternal(item.url));
		},
	},

	methods: {
		isExternal(url) {
			if (url) {
				if (
					['http://', 'https://', 'ftp://'].some(
						(str) => url.indexOf(str) === 0
					)
				) {
					return true;
				}

				const splitOut = url.split('/');
				if (splitOut[0].indexOf('.') >= 0) {
					return true;
				}
			}

			return false;
		},
	},
};
</script>

<style lang="postcss">
.c-search-section-page__button {
	border-width: 1.5px !important;
}
</style>
